<template>
  <div>
    <hero-d-l
      logo="assets/img/DL-logo2022.png"
      :intro="intro"
      buttonLink="/digitalleaders2022/meta-ranking"
      buttonText=" Global Digital Leaders 2022"
    />
    <categ2022 articleId="62751df346758f0219c699a1" :condition="categ" />
    <one-column-image-right
      slug="Methodology"
      buttonText="Download PDF"
      buttonLink="/assets/files/methodology2022.pdf"
    />
    <!-- <part4></part4> -->

    <dark-1-columns-image-right
      articleId="6274f20646758f0219c699a0"
      buttonText="Download PDF"
      buttonLink="/assets/files/pr2022.pdf"
    ></dark-1-columns-image-right>

    <one-column-image-right slug="Why-Digitalisation" />
  </div>
</template>
<script>
import Categ2022 from '@/components/home/Categ2022';
import OneColumnImageRight from '@/components/common/OneColumnImageRight';
// import Part4 from '@/components/home/Part4';
import Dark1ColumnsImageRight from '@/components/common/Dark1ColumnsImageRight';
import HeroDL from '../components/home/HeroDL.vue';

export default {
  components: {
    Categ2022,
    OneColumnImageRight,
    //Part4,
    Dark1ColumnsImageRight,
    HeroDL
  },
  data() {
    return {
      intro:
        'Global Digital Leaders 2022 is the ranking of the top 200 best universities for digital education worldwide. Built out of  five category rankings, it reveals the names of institutions which are championing the digital skills agenda  in 2022',
      categ: {
        view: 'categ2022'
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
